<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
      :selection="false"
    />
  </div>
</template>

<script>
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Baimingdanguanli',
  components: {},
  data() {
    return {
      url: '/business/whitelist/page',
      columns: [
        {
          label: '名称',
          prop: 'whiteListName'
        },
        {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      // 操作栏
      handles: {
        width: 260,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'pile.whiteList.details',
            handle: resp => {
              this.$router.push({ path: './whiteListDetail', query: { data: resp.id }})
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'pile.whiteList.update',
            handle: resp => {
              this.$router.push({ path: './reviseWhiteList', query: { data: resp.id }})
            }
          },
          {
            label: '删除',
            permission: 'pile.whiteList.delete',
            style: 'color:red',
            isConfirm: true,
            url: '/business/whitelist/delete',
            method: 'delete',
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                id: record.id
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '名称',
          prop: 'whiteListName',
          placeholder: '请输入名称'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'pile.whiteList.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addWhiteList')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/plantManagement/whiteList.vue